export function cycleCssClass(status) {
  if (status <= 100) {
    return 'success'
  }
  if (status > 100) {
    return 'danger'
  }
}
